import * as React from "react";
import { Grid2, Typography } from "@mui/material";
import { useBatteryConfig, useBatteryInfo, useBatteryStructure, } from "../../../../Pages/DigitalTwinV3/DigitalTwinContext";
import { DigitalTwinTabContainer } from "../../../../Theme/DigitalTwinStyles";
import { useTranslation } from "react-i18next";
import BatteryHealthSidebar from "./BatteryHealthSidebar";
import BatteryHealthChartSection from "./BatteryHealthChartSection";
import BatteryLifecycleMetrics from "./BatteryLifecycleMetrics";


export default function BatteryHealth({ batteryID }) {
    const { t } = useTranslation()

    const { batteryInfo } = useBatteryInfo()
    const batteryConfig = useBatteryConfig()
    const batteryStructure = useBatteryStructure()

    return (
        <DigitalTwinTabContainer >
            {/* <BatteryHealthKPI batteryID={batteryID} /> */}

            <Grid2 container flexDirection="column" gap="4px" paddingBottom={'20px'} paddingTop={'4px'} paddingLeft={'12px'}>
                <Typography variant="fw500s16lh20c000000"> {t('SOH Degradation Curve')} </Typography>
                <Typography variant="fw400s12c686868">{t(`View how the SOH of your battery has changed with age or cycles completed`)}</Typography>
            </Grid2>

            <Grid2 container sx={{
                borderRadius: '14px',
                border: '1px solid #E6E6E6',
                backgroundColor: '#FFF',
                height: '416px',
                flexWrap: 'nowrap',
                pr: 1.2
            }} >
                <Grid2 sx={{ width: '20%', flexShrink: 0, borderRight: '1px solid #E6E6E6', zIndex: 1, mr: 1.2 }}>
                    <BatteryHealthSidebar
                        batteryStructure={batteryStructure}
                        batteryConfig={batteryConfig}
                        hierarchyLevel={'pack'}
                        onChangeNode={() => { }}
                        maxLevel={0}
                    />
                </Grid2>

                <Grid2 flexGrow={1} sx={{ mr: 1.2 }}>
                    <BatteryHealthChartSection batteryID={batteryID} />
                </Grid2>

            </Grid2>

            <Grid2 container flexDirection="column" gap="4px" paddingTop={'20px'} paddingLeft={'12px'}>
                <Typography variant="fw500s16lh20c000000">{t(`Battery Lifecycle Metrics`)}</Typography>
            </Grid2>

            <Grid2 sx={{ mb: 10 }}>
                <BatteryLifecycleMetrics
                    batteryStructure={batteryStructure}
                    batteryInfo={batteryInfo} />
            </Grid2>

        </DigitalTwinTabContainer>
    )
}
